export default "__VITE_ASSET__9c5c783a__"